import IAdmissionRepository from "../4_Repositories/IAdmissionRepository";

export default class GetSummaryUseCase {
  private readonly _repository: IAdmissionRepository;

  constructor(repository: IAdmissionRepository) {
    this._repository = repository;
  }

  public async execute() {
    const entities = await this._repository.getSummary();

    return entities.toJSON();
  }
}
